import Model from './Model'

export default class Withdrawal extends Model {
  resource() {
    return 'account/withdrawals'
  }
}
